export default __webpack_public_path__ + "static/media/dashboard2.223ba707.png";